module.exports = __webpack_public_path__ + "49877c02937a1d0e0fb0f89c853dbef4.pdf";